<template>
  <div class="messages">
    <button v-if="!writing" @click="writing = true" class="button button--sec">{{ getUiString(['claim_details', 'claim', 'respond']) }}</button>
    <div v-if="writing" class="data-edit data-edit--gradient">
      <form class="data-edit__content">
        <lennoc-spinner v-if="isBusy" isFullscreen="false"></lennoc-spinner>
        <h3 class="data-edit__title title--m">{{ getUiString(['claim_details', 'claim', 'respond']) }}</h3>
        <lennoc-text-area
          v-model="userMessage"
          id="textarea"
          label="Bericht"
          :validators="emptyValidators"
          :domClass="externalError('userMessage', emptyValidators)"></lennoc-text-area>
        <div class="form__group--error"
          v-if="renderGroupValidation && !validate">
          <div class="error">{{ getUiString(['general', 'no_input_warning']) }}</div>
        </div>
        <div :class="eventHostClass"
          @mousedown="groupValidation">
          <button @click.prevent="sendMessage"
            :disabled="!validate"
            class="button button--prim">{{ getUiString(['claim_details', 'claim', 'send']) }}</button>
        </div>
        <a class="link link--edit" href="#" @click.prevent="writing = false">
          <lennoc-icon image="edit" />
          <span>{{ getUiString(['claim_details', 'claim', 'cancel_button']) }}</span>
        </a>
      </form>
    </div>
    <div v-if="showResult" class="data-edit data-edit--gradient">
      <h3 class="title--l">{{ getUiString(['claim_details', 'claim', 'message_sent']) }}</h3>
      <p>{{ getUiString(['claim_details', 'claim', 'message_sent_text']) }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { novalidator } from '@/validators/index'

export default {
  name: 'ClaimReactButton',
  props: {
    rootMessage: {
      type: Object,
      required: true
    },
    setTaskPerformed: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      isBusy: false,
      showResult: false,
      userMessage: '',
      writing: false,
      renderGroupValidation: false
    }
  },
  watch: {
    userMessage () {
      this.renderGroupValidation = false
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString'
    }),
    emptyValidators () {
      const vld = novalidator
      novalidator.message = this.getUiString(['general', 'no_input_warning'])
      return [vld]
    },
    eventHostClass () {
      return !this.validate ? 'event-host--block' : 'event-host'
    },
    validate () {
      return this.emptyValidators[0].validate(this.userMessage)
    }
  },
  methods: {
    externalError (data, validator) {
      if (this.renderGroupValidation && !validator[0].validate(this[data])) {
        return 'form__group--error'
      }
    },
    groupValidation () {
      this.renderGroupValidation = true
    },
    sendMessage () {
      this.isBusy = true
      const msg = {
        documentId: this.rootMessage.Id,
        subject: `RE: ${this.rootMessage.Description}`,
        body: this.userMessage,
        confirm: this.setTaskPerformed
      }
      this.$store
        .dispatch('claim/sendMessage', msg)
        .then(result => {
          this.writing = false
          this.showResult = true
          this.userMessage = ''
          this.$store.dispatch('claim/refreshClaim')
          setTimeout(() => {
            this.showResult = false
          }, 2000)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.isBusy = false
        })
    }
  }
}
</script>
